export default "__VITE_ASSET__DDHekT1J__"